import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import Attachments from '../../../shared/UI/Attachments/Attachments'; 
import moment from 'moment';
import UploadImage from '../../../assets/images/uploadImg.svg';
import readXlsxFile from 'read-excel-file';
import { Accordion, AccordionTab } from 'primereact/accordion';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import lodash from 'lodash';
import { apcologo } from '../../../shared/fontsAndBitImages';
import { MultiSelect } from 'primereact/multiselect';



const Inputs = ({ field, metaData, onInputChange, ...props }) => {

    const Component = ImplementationFor[field.fieldType] || false;
    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={metaData}
    /> || null;

}

const DEMOBLIZATION_ID = '1cf4350f-2845-4246-afe2-80aaf5a7b712';


class DeMoblization extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            processInitiated: false,
            stageSequence: 0,
            fromDate: false,
            toDate: false,
            requestDate: moment(),
            otType:false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            employees: false,
            OTHours: false,
            requestId: false,
            popupType: 'submit',
            activeIndex: false,
            requestattachments: [],
            workorderno: '',
            Reason:'',
            employees: []
        }
        this.initialize = this.initialize.bind(this);
        this.readFromExcel = this.readFromExcel.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this);
        this.handleExcel = this.handleExcel.bind(this);
    }
    getNextWorkingDate = (otempid) => {
        this.setState({loading:true});
        const { requestedFor, fromDate } = this.state;
        //const reportingDate = moment(toDate).add(1, 'days');
        axios.get(`/master/api/GetTotalOTDone?id=${otempid}`).then(response =>{
            this.setState({loading:false});
            return response.data.OTDone
        }).catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'Total OT Hour API Failed'});
            this.setState({loading:false});
        })  
    }

    

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value,type, checked } = e.target;

        if (el) {
            let selIndex = 0;
            let selEmployees = el.fieldDescription === 'Employees' && value || [];
            const process = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage.stage_Field.map(field => {
                    let EmployeeId = null;
                    if (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') {
                        if (parseInt(selIndex) === selEmployees.length) {
                            selIndex = 0;
                        }
                        EmployeeId = selEmployees && selEmployees.length > 0 && selEmployees[selIndex] || null;
                        selIndex++;
                    }
                    return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') ? EmployeeId :(field.fieldDescription === "OT Type" && el.fieldDescription === 'OT Type') ? value : (type === 'checkbox' && field.fieldName === name) ? checked: (field.fieldDescription === "Employees" && el.fieldDescription === 'Employees') ? value.map(c => c).join(',') : field.fieldName === name ? value : (el.fieldDescription === 'OT Hours' && field.fieldDescription === 'Hours') ? value  : field.fieldValue })
                })
            }));

            this.setState({
                fromDate: el.fieldDescription === "From Date" ? value : this.state.fromDate,
                toDate: el.fieldDescription === "To Date" ? value : this.state.toDate,
                employees: el.fieldDescription === "Employees" ? value.map(c => c).join(',') : this.state.employees,
                OTHours: el.fieldDescription === "OT Hours" ? value : this.state.OTHours,
                requestDate: el.fieldDescription === "Request Date" ? value : this.state.requestDate,
                process,
                otType: el.fieldDescription === "OT Type" ? value : this.state.otType,
                workorderno: el.fieldDescription === "Work Order No." ? value : this.state.workorderno,
                Reason:el.fieldDescription === "Reason" ? value : this.state.Reason,
            });

        }
    }

    initialize = (process, type) => {
        const { tableLists, location = {} } = this.props;
        const { stageSequence, fromDate, toDate, employees, OTHours, requestDate, otType,workorderno,Reason } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;

        let count = 1;
        let sequence = 1;
        let start = new Date(fromDate);
        let end = new Date(toDate);

        if ((type === 'progress' && fromDate && toDate && employees && start <= end) || type === 'add' || type === 'edit' || type === 'request') {


            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if ((type === 'add' && stageIndex === 0 && (el.fieldDescription === "From Date" ||el.fieldDescription === "Work Order No." ||el.fieldDescription === "Reason" || el.fieldDescription === "To Date" || el.fieldDescription === "Employees" || el.fieldDescription === "OT Hours" || el.fieldDescription === "OT Type")) || (type === 'add' && stageIndex > 0)) {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: el.fieldDescription === "Request Date" && requestDate || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:false});
                        } else if (type === 'progress' && el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = employees.split(',');
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                                selEmployees.map(sel => {
                                    let startDate = new Date(fromDate);
                                    let endDate = new Date(toDate);
                                    if (fromDate && toDate && startDate <= endDate) {
                                        while (startDate <= endDate) {
                                            fields.map((subField) => {
                                                let formatDate = new Date(startDate);
                                                a.push(Object.assign({}, { ...subField },
                                                    {
                                                        childRowNmbr: loopIndex,
                                                        fieldName: `${startIndex}${count++}`,
                                                        fieldSequence: sequence++,
                                                        groupingfieldvalue: sel,
                                                        stageSequence: stageIndex,
                                                        stageNum: `00${stageIndex}`,
                                                        fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && sel) || (subField.fieldDescription === 'OT Type' && otType) || subField.fieldValue
                                                    }));

                                            });
                                            loopIndex++;
                                            startDate.setDate(startDate.getDate() + 1);
                                        }
                                    }

                                });

                            }
                            this.setState({processInitiated:true});

                        } else if (type === 'progress' && el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "From Date" && fromDate) ||(el.fieldDescription === "Work Order No." && workorderno) ||(el.fieldDescription === "Reason" && Reason) || (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "OT Hours" && OTHours) || (el.fieldDescription === "To Date" && toDate) || (el.fieldDescription === "Request Date" && requestDate) || (el.fieldDescription === "OT Type" && otType) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:true});
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence && pendingWith !== null ) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                                        })
                                    }
                                })
                            }
                            this.setState({processInitiated:true});
                        } else if(type === "bulkUpload"){
                            
                        }
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);

            setTimeout(this.handleExcel.bind(this), 5000);


        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }
    }
    

    readFromExcel = (vals, process) => {
        const input = document.getElementById('bulkUploadFile');
        if (input){
        const { stageSequence, requestDate, fromDate, toDate, employees, OTHours, otType,workorderno,Reason } = this.state;

        const { keywordValuesList: empList,metaData} = this.props;


        let count = 1;
        let sequence = 1;
        
        let empmoblizationData = [] // contains an arry of obj with each obj having empid empname month of the ot year of the ot and hour for each specific day at "hours" key
            let DemoblizeStatuslist= metaData["Status"]

        readXlsxFile(input.files[0]).then((otData) => {
            let otDays = otData[0].slice(4)
            var monthc = "";
            otData.forEach((row, rowIndex) => {
                if (rowIndex > 0) { // ignoring the first row since it is the header
                   otData = {}
                  
                    otData.empId = empList.find(emp => emp.id === parseInt(row[0]))?.value || row[0]
                    otData.employeename = row[1]
                    otData.status = row[2]!=null ? DemoblizeStatuslist.find(status => status.id === row[2] || status.label.toLowerCase() === row[2].toLowerCase() )?.value || row[2] : row[2]
                    otData.demobilizedate = row[3]

                   // otData.hours = otDays.map((day, i) => [day, otHours[i]])
                   empmoblizationData.push(otData)
                   
                }
            })
            
            

 

        if (empmoblizationData) {
            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = empmoblizationData;
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                                selEmployees.forEach(sel => {
                                    var { empId,employeename , status , demobilizedate } = sel


                              
                                      
                             
                                        fields.map((subField) => {
                                            //let formatDate = new Date(year, month, otDay

                                          
                                            a.push(Object.assign({}, { ...subField },
                                                {
                                                    childRowNmbr: loopIndex,
                                                    fieldName: `${startIndex}${count++}`,
                                                    fieldSequence: sequence++,
                                                    groupingfieldvalue: sel.empId,
                                                    stageSequence: stageIndex,
                                                    stageNum: `00${stageIndex}`,
                                                    fieldValue:  (subField.fieldDescription === 'Employee Id' && empId) || (subField.fieldDescription === 'Status' && status) || (subField.fieldDescription === 'Demoblize Date' && demobilizedate)  || subField.fieldValue
                                                }));

                                        });
                                        loopIndex++;
                                 
                                });

                            }
                            this.setState({processInitiated:true});

                        }else if (el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "From Date" && fromDate) ||(el.fieldDescription === "Work Order No." && workorderno) ||(el.fieldDescription === "Reason" && Reason) || (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "OT Hours" && OTHours) || (el.fieldDescription === "To Date" && toDate) || (el.fieldDescription === "Request Date" && requestDate) || (el.fieldDescription === "OT Type" && otType) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:true});
                        } 
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);

            setTimeout(this.readFromExcel.bind(this), 5000);


        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

        })

    }


    }



    handleExcel = () => {
        const input = document.getElementById('file-8');
        if (input) {
            input.addEventListener('change', () => {
                this.setState({ loading: true });
                const { keywordValuesList: empList} = this.props;
                const { initialData, stageSequence, requestDate } = this.state;

                let count = 1;
                let sequence = 1;
                let EmployeeList = [];
                let FromDate = false;
                let ToDate = false;

                const process = initialData.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    return Object.assign({}, { ...stage }, {
                        stage_Field: stageField.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, el.fieldName.length - 1);
                            if (el.fieldType === '9') {
                                const container = stageField.find(_ => _.fieldType === '9');
                                const name = container.fieldName;
                                const fields = stageField.filter(_ => _.parentFieldId === name);

                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));


                                readXlsxFile(input.files[0]).then((rows) => {
                                    let loopIndex = 0;
                                    rows.map((row, rowIndex) => {
                                        let selEmployee = rows[0]
                                        let month = rows[2]
                                        let year = rows[3]
                                        if (rowIndex > 0) {
                                            row.map((el, i) => {
                                                if (i > 3 && selEmployee && month && year ) {
                                                    let formatDate = new Date(moment(`${month}, ${rows[0][i]} ${year}`));
                                                    let OTHours = (el === null || el === 'null') ? '0' : el.toString();
                                                    FromDate = (i === 4 && rowIndex === 1) && formatDate || FromDate;
                                                    ToDate = (i === (row.length - 1) && rowIndex === 1) && formatDate || ToDate;

                                                    const emps = fields.map((subField) => ({
                                                                childRowNmbr: loopIndex,
                                                                fieldName: `${startIndex}${count++}`,
                                                                fieldSequence: sequence++,
                                                                groupingfieldvalue: selEmployee.value,
                                                                fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && selEmployee && selEmployee.value) || subField.fieldValue,
                                                                stageSequence: stageIndex, 
                                                                stageNum: `00${stageIndex}`
                                                            }))


                                                    
                                                    EmployeeList.push(selEmployee);
                                                    fields.map((subField) => {
                                                        a.push(Object.assign({}, { ...subField },
                                                            {
                                                                childRowNmbr: loopIndex,
                                                                fieldName: `${startIndex}${count++}`,
                                                                fieldSequence: sequence++,
                                                                groupingfieldvalue: selEmployee.value,
                                                                fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && selEmployee && selEmployee.value) || subField.fieldValue,
                                                                stageSequence: stageIndex, 
                                                                stageNum: `00${stageIndex}`
                                                            }));

                                                    });
                                                    loopIndex++;
                                                }

                                            })

                                            
                                        }
                                    })
                                })


                            } else if (el.parentFieldId === '000') {
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: el.fieldDescription === 'Request Date' && requestDate || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            }
                            return a;
                        }, [])
                    })
                });


                if (process && process.length > 0)
                    setTimeout(() => {
                        this.setState({ loading: false, process, employees: EmployeeList && Array.isArray(EmployeeList) && EmployeeList.length > 0 ? [...new Set(EmployeeList.map(e => e.value))].join(',') : [], fromDate: FromDate, toDate: ToDate })
                    }, 4000);

            })
        }

    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
        this.setState({requestattachments:attachmentData});
    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process, fromDate, toDate, employees, processInitiated,workorderno,Reason } = this.state;
        const type = this.props.match.params.type;

        if(!processInitiated){
            this.growl.show({ severity: 'error', summary: null, detail: 'Please Initiate before Submitting/Saving' });
            this.setState({ loading: false })
            return;
        }

        let FromDate = fromDate;
        let ToDate = toDate;
        let Workordernum = workorderno;
        let reason = Reason;
        let RequestDate = new Date();
        let Comment = '';
        let RequestAttributes = [];
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {
                if (el.fieldDescription === 'From Date') {
                    el.fieldValue = fromDate || el.fieldValue;
                    FromDate = el.fieldValue || FromDate; 
                } else if (el.fieldDescription === 'To Date') {
                    el.fieldValue = toDate || el.fieldValue;
                    ToDate = el.fieldValue || ToDate;
                } else if (el.fieldDescription === 'Employees') {
                    el.fieldValue = employees || el.fieldValue;
                } else if (el.fieldDescription === 'Request Date' && el.fieldValue) {
                    RequestDate = el.fieldValue;
                } else if (el.fieldDescription === 'Comment' && stageIndex === 0) {
                    Comment = el.fieldValue;
                }else if (el.fieldDescription === 'Work Order No.') {
                    el.fieldValue = workorderno || el.fieldValue;
                    Workordernum = el.fieldValue || Workordernum;
                }else if (el.fieldDescription === 'Reason') {
                    el.fieldValue = toDate || el.fieldValue;
                    reason = el.fieldValue || reason;
                }
                
                RequestAttributes.push(Object.assign({}, {...el}, {fieldValue: (el.fieldType === "7" || el.fieldType === "8" || (el.fieldType === "1" && el.fieldStatus === "Display Only")) ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue}));
            })
        });



        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'DeMoblization Request',
            IsActive: true,
            RequestDate: RequestDate && moment(RequestDate),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: DEMOBLIZATION_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'DeMoblization';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'DeMoblization';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'DeMoblization';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'DeMoblization';
            }
            

            if (submitType === 'cancel') {
                model = 'DeMoblization';
            }

            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            
            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });
            
            axios.post(url, JSON.stringify(datas))
                .then(response => {
                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                    })
                                }

                                if(submitType === 'return'){
                                    this.setState({popupType: 'return'});
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'DeMoblization request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'DeMoblization request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed' });
                })

        }

    }

    componentDidMount() {
        
        const { getContainerData, getMasterKeywordList, getKeywordValues, fetchSubordinatesLists, loggedUserDetail, location = {} } = this.props;
        const type = this.props.match.params.type;
        getContainerData(DEMOBLIZATION_ID);//Get Container Data
        getMasterKeywordList('Shift');// Get Shift Dropdown list

        getMasterKeywordList('OTType');//Get Employee Dropdown list
        getMasterKeywordList('DemoblizeStatus');//Get Employee Dropdown list

        if (type != 'edit') {
                getKeywordValues('Employee');//Get Employee Dropdown list
                fetchSubordinatesLists(loggedUserDetail.empID, loggedUserDetail.CompanyId);//Fetch subordinate api list
        }

        if (type === 'edit') {
             getKeywordValues('Employeeall');//Get Employee Dropdown list
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists = {}, containerData } = this.props;
            const { employeeID, companyID } = tableLists;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({requestattachments});

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || [];
            }

            if (process && process.length > 0 && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                
                if (employeeID && companyID)
                    fetchSubordinatesLists(employeeID, companyID);//Fetch subordinate api list
                
                clearTimer();
            }
        }, 300);


    }

    handleMethods(type) {
        this.setState({ popupType: type });
        const { keywordValuesList } = this.props;
        this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesList })
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, keywordValuesList: [], subordinatesListData: [] })
    }

    handleTabChange(e) {
        this.setState({ loading: true, activeIndex: e.index })
        setTimeout(() => this.setState({ loading: false }), 3000);
    }

    Change = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value }); // Update state with selected values
    };
    

    downloadOtTemplate() {
        axios({
            url: `/master/api/Download?filename=DeMobilization.xlsx&&FolderName=DeMobilization&&ext=.xlsx`,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `DeMobilization.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.setState({loading: false})
          }).catch((err) => {
            this.growl.show({ severity: 'error', summary: 'null', detail: 'File Download failed, please try again.' });
          })







          
    }
    downloadPDF = (type) => {

        const emp = this.state.employees;
        const empprops = this.props.metaData["Employee Id"]
        
        const empnames = [];

        // Iterate through each item in emp
        Object.values(emp).forEach((empValue) => {
        // Find the matching item in empprops
        const matchingProp = empprops.find((prop) => prop.value === empValue);

        if (matchingProp) {
            // Extract name and department from the label
            const [name, deptWithParen] = matchingProp.label.split("- (");
            const dept = deptWithParen.split(")-")[1]?.trim() || "";

            // Push the name and department to empnames array
            empnames.push({ name: name.trim(), dept: dept });
        }
        });

        empnames.forEach((employee) => {
            
        const process = this.state.process;
        const stage_Field = process[0]?.stage_Field || "";

        const employeeIdFieldValues = stage_Field
              .filter(field => field.fieldDescription === "Employee Id")
              .map(field => field.fieldValue);

        const requestDate = stage_Field.find(field => field.fieldId === "d2e86178-d986-47db-a271-3375958a76a4");

        const reqDate = requestDate.fieldValue ? new Date(requestDate.fieldValue) : null;

        



         // pdf generation starts
         var doc = new jsPDF('p', 'mm', 'a4', 3);//jsPDF(orientation, unit, format)
         let text = '';
         doc.setFontStyle('normal');
         doc.setFont("Courier");  
         doc.setFontSize(10);

    
        try {
            // Header Section
            doc.autoTable({
                theme: 'plain', 
                startY: 9,
                margin: {
                    left: 8.5
                },
                columnStyles: {
                    0: { cellWidth: 50 }, // Adjust logo column width
                    1: { cellWidth: 200 } // Adjust text column width to shift text
                },
                body: [
                    [
                        { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                        {
                            content: "ARABIAN PIPECOATING COMPANY",
                            styles: {
                                halign: 'left',
                                valign: 'middle',
                                fontStyle: 'bold', 
                                fontSize: 14, 
                                textColor: 'black',
                                cellPadding: { top: 5, left: 6, right: 0 }, 
                                borderColor: 'white',
                                lineHeight: 1.2
                            }
                        }
                    ],
                    [
                        { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                        {
                            content: "CONTRACT/SUB CONTRACT\nDEMOBILIZATION FORM",
                            styles: {
                                halign: 'left',
                                valign: 'middle',
                                fontStyle: 'normal', 
                                fontSize: 10, 
                                textColor: 'black',
                                cellPadding: { top: 0, left: 6, right: 0 }, 
                                borderColor: 'white',
                                lineHeight: 1.2
                            }
                        }
                    ]
                ]
            });
            
            // Add the logo separately
            doc.addImage(apcologo, 'PNG', 10, 10, 40, 20); // Adjust position and size as needed
            

            doc.setDrawColor(0, 0, 0); // Set border color to black
            doc.setLineWidth(0.5);
            doc.rect(160, 3, 40, 25); // Move box further up by setting y to 3

            // Add text inside the box
            doc.setFont('Helvetica', 'bold');
            doc.setFontSize(10);
            doc.text("Form No: HRF- 010 ", 163, 9); // Adjusted y position for Form No
            doc.text("REV'S: ____________", 163, 16); // Adjusted y position for Section
            doc.text("Date: ____________", 163, 23); // Adjusted y position for Date

            doc.setLineWidth(0.5);
            doc.line(10, 30, 200, 30);
              
            // Text content for the line below the header
            const lineText = "The following has to be filled and signed by the department head of the concerned department";
            doc.setFont('Helvetica', 'normal');
            doc.setFontSize(10);
            const textWidth = doc.getTextWidth(lineText);
            doc.text(lineText, (200 - textWidth) / 2, 35); // Center the text

        // Initialize variables properly
            let previousTableEnding = doc.lastAutoTable?.finalY || 0; // Ensure `doc.lastAutoTable` is handled safely

            // Big Rectangle Section
            const boxMargin = 10; // Margin from the left
            const boxYStart = previousTableEnding + 10; // Start position for the rectangle
            const boxHeight = 25; // Height of the rectangle

            // Draw the first rectangle
            doc.rect(boxMargin, boxYStart, 190, boxHeight);

            // Add content inside the first rectangle
            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Employee Name: "+employee.name , boxMargin + 5, boxYStart + 10);
            doc.text("c#: ____________________", boxMargin + 75, boxYStart + 10);
            doc.text("Position: ____________________", boxMargin + 120, boxYStart + 10);
            doc.text("Department: "+employee.dept, boxMargin + 5, boxYStart + 20);
            doc.text("Date Of Release:  " + reqDate.toLocaleDateString('en-GB'), boxMargin + 90, boxYStart + 20);

            // Update previousTableEnding after the first rectangle
            previousTableEnding = boxYStart + boxHeight;


            // Add explanatory text
            const text = "The above employee has handed over to me the following as indicated below:";
            doc.setFont("Helvetica", "bold"); // Set font to bold
            doc.setFontSize(10);
            doc.text(text, 10, previousTableEnding + 5); // Position text below the first rectangle



            // Second Rectangle Section
            const boxYStart2 = previousTableEnding + 8; // Start position for the second rectangle
            const boxHeight2 = 35; // Height of the second rectangle

            // Draw the second rectangle
            doc.rect(boxMargin, boxYStart2, 190, boxHeight2);

            // Add content inside the second rectangle
            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Concerned dept.Supervisor: ____________________", boxMargin + 5, boxYStart2 + 8);
            doc.text("Supervisor Comments:  _______________________", boxMargin + 90, boxYStart2 + 8);
            doc.text("Tools:                   ____________________", boxMargin + 5, boxYStart2 + 16);
            doc.text("       _________________________________", boxMargin + 90, boxYStart2 + 16);
            doc.text("Equipment:           ____________________", boxMargin + 5, boxYStart2 + 24);
            doc.text("__________________________________", boxMargin + 90, boxYStart2 + 24);
            doc.text("Keys:                   ____________________", boxMargin + 5, boxYStart2 + 32);
            doc.text("__________________________________", boxMargin + 90, boxYStart2 + 32);



            //checkbox alignment
            doc.rect(boxMargin + 23, boxYStart2 + 14, 3, 3); // Checkbox near "Tools, Equipment, Keys"
            doc.rect(boxMargin + 23, boxYStart2 + 22, 3, 3);
            doc.rect(boxMargin + 23, boxYStart2 + 29, 3, 3);


            // Update previousTableEnding after the second rectangle
            previousTableEnding = boxYStart2 + boxHeight2;



            const boxYStart3 = previousTableEnding + 2; // Start position for the second rectangle
            const boxHeight3 = 27;
            // Draw the rectangle
            doc.rect(boxMargin, boxYStart3, 190, boxHeight3);

            // Add content inside the rectangle
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Time Office:", boxMargin + 5, boxYStart3 + 5); 

            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Supplier Name :", boxMargin + 5, boxYStart3 + 10);

            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Date of Join:__________________", boxMargin + 110, boxYStart3 + 10);


            doc.text("Camp                :", boxMargin + 5, boxYStart3 + 17); 

            doc.text("Demobilization Fax:", boxMargin + 5, boxYStart3 + 24);
            doc.rect(boxMargin + 35, boxYStart3 + 22, 3, 3); //checkbox

            // Add Time Keeper at the bottom
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Time Keeper", boxMargin + 160, boxYStart3 + 25);



            previousTableEnding = boxYStart3 + boxHeight3;



            const boxYStart4 = previousTableEnding + 2; // Start position for the second rectangle
            const boxHeight4 = 27; 

            // Draw the rectangle
            doc.rect(boxMargin, boxYStart4, 190, boxHeight4);

            // Add content inside the rectangle
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Camp :", boxMargin + 5, boxYStart4 + 5); 


            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Room Key                            _____________________", boxMargin + 40, boxYStart4 + 10);
            doc.rect(boxMargin + 60, boxYStart4 + 8, 3, 3); 

            doc.text("Pillow                                    _____________________", boxMargin + 40, boxYStart4 + 15);
            doc.rect(boxMargin + 60, boxYStart4 + 13, 3, 3);  

            doc.text("Mattress                                _____________________", boxMargin + 40, boxYStart4 + 20);
            doc.rect(boxMargin + 60, boxYStart4 + 18, 3, 3); 


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Camp Supervisor", boxMargin + 155, boxYStart4 + 25);



            previousTableEnding = boxYStart4 + boxHeight4;


            const boxYStart5 = previousTableEnding + 2; // Start position for the second rectangle
            const boxHeight5 = 22; 

            // Draw the rectangle
            doc.rect(boxMargin, boxYStart5, 190, boxHeight5);

            // Add content inside the rectangle
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Safety :", boxMargin + 5, boxYStart5 + 5); 


            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Helmet                            _____________________", boxMargin + 40, boxYStart5 + 10);
            doc.rect(boxMargin + 60, boxYStart5 + 8, 3, 3); 

            doc.text("Safety Glass                    _____________________", boxMargin + 40, boxYStart5 + 15);
            doc.rect(boxMargin + 60, boxYStart5 + 13, 3, 3);  


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Store", boxMargin + 170, boxYStart5 + 20);


            previousTableEnding = boxYStart5 + boxHeight5;



            const boxYStart6 = previousTableEnding + 2; // Start position for the second rectangle
            const boxHeight6 = 33;
            // Draw the rectangle
            doc.rect(boxMargin, boxYStart6, 190, boxHeight6);

            // Add content inside the rectangle
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Reason for release :-", boxMargin + 5, boxYStart6 + 5); 

            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);

            doc.text("Vacation Scheduled", boxMargin + 5, boxYStart6 + 10);
            doc.rect(boxMargin + 37, boxYStart6 + 8, 3, 3); //checkbox


            doc.text("Termination", boxMargin + 5, boxYStart6 + 17); 
            doc.rect(boxMargin + 37, boxYStart6 + 15, 3, 3); //checkbox


            doc.text("Emergency", boxMargin + 5, boxYStart6 + 24);
            doc.rect(boxMargin + 37, boxYStart6 + 21, 3, 3); //checkbox


            doc.text("Others", boxMargin + 5, boxYStart6 + 31);
            doc.rect(boxMargin + 37, boxYStart6 + 27, 3, 3); //checkbox


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(9);
            doc.text("Deductions :-  Yes  /  No ", boxMargin + 70, boxYStart6 + 10);


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(9);
            doc.text("ID Card :-  Yes  /  No ", boxMargin + 70, boxYStart6 + 20);


            doc.text("No.of.Days :-", boxMargin + 70, boxYStart6 + 30);
            doc.rect(boxMargin + 95, boxYStart6 + 25, 15, 7); //checkbox


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Replacement :-", boxMargin + 135, boxYStart6 + 5);


            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("Required", boxMargin + 135, boxYStart6 + 15);
            doc.rect(boxMargin + 167, boxYStart6 + 13, 3, 3); //checkbox


            doc.text("Not Required", boxMargin + 135, boxYStart6 + 25);
            doc.rect(boxMargin + 167, boxYStart6 + 22, 3, 3); //checkbox



            previousTableEnding = boxYStart6 + boxHeight6;


            const boxYStart7 = previousTableEnding + 2; // Start position for the second rectangle
            const boxHeight7 = 40; // Height of the second rectangle

            // Draw the second rectangle
            doc.rect(boxMargin, boxYStart7, 190, boxHeight7);

            // Add content inside the second rectangle
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text(" Other belongings:", boxMargin + 5, boxYStart7 + 5);


            doc.setFont("Helvetica", "normal");
            doc.setFontSize(9);
            doc.text("others:                   ____________________", boxMargin + 5, boxYStart7 + 13);
            doc.rect(boxMargin + 23, boxYStart7 + 11, 3, 3);


            doc.text("                          ____________________", boxMargin + 60, boxYStart7 + 13);
            doc.rect(boxMargin + 78, boxYStart7 + 11, 3, 3);


            doc.text("       :                   ____________________", boxMargin + 115, boxYStart7 + 13);
            doc.rect(boxMargin + 133, boxYStart7 + 11, 3, 3);


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Name & Signature", boxMargin + 5, boxYStart7 + 27);


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text(" 'All hired employees residing in APCO camp, who is going on finish should ", boxMargin + 5, boxYStart7 + 32);
            doc.text(" surrender this clearancecertificate to the security while leaving' ", boxMargin + 5, boxYStart7 + 36);


            doc.setFont("Helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Authorized Signature", boxMargin + 150, boxYStart7 + 37);
            doc.rect(boxMargin + 145, boxYStart7 + 17, 45, 54);

            const footerContent = [
                { label: "DRAWN BY: ", value: "FAF                         FORM REV'S  " },
                { label: "CHECKED BY: ", value: "BB" },
                { label: "APPROVED BY: ", value: "KHD                        BY:-" },
                { label: "DATE: ", value: "                                DATE:-" }
            ];

            let yPosition = 276;
            const lineOffset = 5;

            footerContent.forEach((row) => {
                doc.text(row.label, 10, yPosition);
                doc.text(row.value, 40, yPosition);
                yPosition += 5;
            });



            doc.text("APPROVAL", 165, 295);

            // Draw Footer Table Borders with offset
            doc.setLineWidth(0.5);
            doc.line(8, 266 + lineOffset, 105, 266 + lineOffset); 
            doc.line(8, 287 + lineOffset, 105, 287 + lineOffset);
            doc.line(8, 272 + lineOffset, 105, 272 + lineOffset);
            doc.line(8, 277 + lineOffset, 105, 277 + lineOffset);
            doc.line(8, 282 + lineOffset, 105, 282 + lineOffset);
            doc.line(8, 266 + lineOffset, 8, 287 + lineOffset);
            doc.line(70, 266 + lineOffset, 70, 287 + lineOffset);
            doc.line(105, 266 + lineOffset, 105, 287 + lineOffset); // Removed this line
            //doc.line(135, 266 + lineOffset, 135, 287 + lineOffset); // Removed this line
            // doc.line(165, 266 + lineOffset, 165, 287 + lineOffset);
            // doc.line(200, 266 + lineOffset, 200, 287 + lineOffset);

            // Update previousTableEnding after the second rectangle
            previousTableEnding = boxYStart7 + boxHeight7;
            
            const processArray = this.state.process.slice(1); // Skip the 0th element
            const approvers = [];

            processArray.some((item, index) => {
                if (item.description) {
                    if (!item.description.includes(',')) {
                        // If no comma, stop the loop
                        return true; // Stops `some()`
                    } else {
                        // Process normally if there are commas
                        const parts = item.description.split(',').map(part => part.trim());
                        const employeeNumber = parts[0].replace("For Release:", "").trim();
                        const employeeName = parts[1].split('-')[0].trim();
                        const position = parts[2].trim();
            
                        approvers[index] = {
                            "employee number": employeeNumber,
                            "employee name": employeeName,
                            "position": position,
                        };
                    }
                }
                return false; // Continue looping
            });
            

            const tableData2 = approvers.map((record, index) => [
                index + 1,
                record["employee number"],
                record["employee name"],
                record["position"]
                
            ]);

            
            if (tableData2.length > 0) {

                // let approversTitleY = previousTableEnding + 50;
                // doc.text("APPROVALS", 105, approversTitleY, { align: "center" });

                doc.autoTable({
                    head: [
                        
                        [
                            { content: "S.no", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Employee Number", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Employee Name", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Position", styles: { fontSize: 10 }, fontStyle: 'bold' }    
                        ]
                    ],
                    body: tableData2,
                    startY: previousTableEnding + 50,// Adjust Y-position
                    margin: { left: 10 },
                    theme: 'grid',// Creates the grid-like style
                    headStyles: {
                        fillColor: [255, 255, 255],// White background
                        textColor: [0, 0, 0], // Black text
                        // fontStyle: 'bold', // Bold header text
                        halign: 'center' // Center alignment for header
                    },
                    bodyStyles: {
                        textColor: [0, 0, 0], // Black text
                        halign: 'center', // Center align text in cells
                        valign: 'middle' // Vertically align text in the middle
                    },
                    styles: {
                        lineWidth: 0.5, // Thin borders
                        lineColor: [0, 0, 0], // Black border color
                        fontSize: 8, // Font size for table content
                    },
                    columnStyles: {
                        0: { cellWidth: 37 }, // S.no
                        1: { cellWidth: 48 }, // Employee Number
                        2: { cellWidth: 53 }, // Employee Name
                        3: { cellWidth: 53 }, // Position  // Date and Time (slightly wider to match total width)
                    }
                });
            }



            // Output PDF based on type
            if (!['print', 'view', 'download', 'upload'].includes(type)) {
                throw new Error("Invalid type specified");
            }
    
            switch (type) {
                case 'print':
                    doc.autoPrint();
                    window.open(doc.output('bloburl'), "sample");
                    break;
                case 'view':
                    window.open(doc.output('bloburl'), "sample");
                    break;
                case 'download':
                    doc.save("Demobilization Form -" +employee.name+ ".pdf");
                    break;
                //  case 'view':
                //     window.open(doc.output('bloburl'), "sample");
                //     break;
                // case 'download':
                //     console.log('Downloading PDF...');
                //     doc.save("VisitorPass.pdf");
                //     break;
                
                case 'upload':
                    const pdf = btoa(doc.output());
                    const generatedPdf = {
                        Key: JSON.stringify({
                            FileName: "Demobilization Form.pdf",
                            Folder: "VisitorPass",
                            Attachment: pdf
                            
                        })
                    };
                    return generatedPdf;
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            this.setState({ loading: false });
        }
    })
    };
    

    
    
    render() {
        console.log("Demoblization",this.props.keywordValuesList)
        const { tableLists, subordinatesListData = [], location = {}, keywordValuesList: empList = [] } = this.props;
        const { state = {} } = location;
        const { fromDate, toDate, process, stageSequence, employees,Reason,workorderno } = this.state; 
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;

        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );

        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            DeMoblization
                            <Link to={'/DeMoblization'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>

                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field = [], description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');

                    const employeeIdFieldValues = stage_Field
                        .filter(field => field.fieldDescription === "Employee Id")
                        .map(field => field.fieldValue);
                    

                    // Transform into dropdown-compatible format
                    const employees = employeeIdFieldValues.map(value => ({
                        label: value, // Displayed in the dropdown
                        value: value, // The actual value selected
                    }));
                    
                    const empprops = empList;
                    const employeeoptions = [];
                    employees.forEach(employee => {
                        empprops.forEach(empprop => {
                            if (empprop.value === employee.value) {
                                const textParts = empprop.text.split("-"); // Split by "-"
                                const name = textParts[0].trim(); // Extract the name
                                const dept = textParts[textParts.length - 1].trim();
                                employeeoptions.push({
                                    label: name,
                                    dept: dept,
                                    value: empprop.value
                                });
                            }
                        });
                    });

                    const containers = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId != '000'), 'groupingfieldvalue'));
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {stageIndex === 0 ? 
                                <div className="p-col-12">
                                    <div className="p-col-12">
                                        <input type="file" name="employeesAttachment" id="bulkUploadFile" className="inputfile inputfile-6 " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"  onChange={(e) => {
                                        const file = e.target.files[0];
                                        this.readFromExcel(file, this.state.initialData);
                                        }}/>
                                        <label htmlFor="bulkUploadFile"><span></span> <strong><img src={UploadImage} alt="upload im" /> Upload DeMoblization File&hellip;</strong></label>                         
                                    </div>
                                    

                                    <div className="p-col-3">
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.downloadOtTemplate()} label="Download DeMobilization Template" icon="pi pi-download" />
                                    </div> 
                                </div> : null}


                                {stageField.filter(_ => _.parentFieldId === '000').map((field, fieldIndex) => {
                                    return <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : field.fieldDescription === "OT Hours" ? "p-col-12 p-md-8 p-lg-8" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldDescription === "OT Hours" ? <div className="p-grid">
                                            <div className="p-col-12 p-md-6 p-lg-6">
                                                <Inputs
                                                    field={field}
                                                    value={field.fieldValue}
                                                    process={process}
                                                    onInputChange={(e) => this.handleChange(e, field)}
                                                    {...this.props}
                                                    {...this.state} />
                                            </div>
                                            <div className="noLableMargin p-col-12 p-md-6 p-lg-6" style={{ marginTop: '2.9em' }}>
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={ () => this.initialize(this.state.initialData, 'progress')} label="Initiate Process" icon="pi pi-upload" />
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null ) ? true : false} onClick={() => this.initialize(this.state.initialData, 'add')} className="ml1 p-button-info" label="Reset" icon="pi pi-refresh" />
                                            </div>
                                        </div> : <Inputs
                                                field={field}
                                                value={(field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',')) || (field.fieldDescription === "Employees" && employees && employees.length > 0 && employees.split(',')) || field.fieldDescription === 'From Date' && !field.fieldValue && fromDate || field.fieldDescription === 'To Date' && !field.fieldValue && toDate || field.fieldDescription === 'Work Order No.' && !field.fieldValue && workorderno|| field.fieldDescription === 'Reason' && !field.fieldValue && Reason || field.fieldValue}
                                                process={process}
                                                onInputChange={(e) => this.handleChange(e, field)}
                                                {...this.props}
                                                {...this.state} />}
                                    </div>

                                })}

                                {this.state.processInitiated && 
                                <Accordion activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange.bind(this)}>
                                    {Object.keys(containers).map((emp, empIndex) => {
                                        const EmployeeField = containers[emp];
                                        const selEmployeeDet = empList.find(_ => _.value === emp) || {};
                                        // const selEmployeeDet = empList.find(_ => _.value === this.state.employees?.[empIndex]) || empList.find(_ => _.value === emp) || {};

                                        const totalHours = EmployeeField.reduce((a, el) => el.fieldDescription === 'Hours' && el.fieldValue ? a + parseInt(el.fieldValue) : a, 0);
                                        const Accemp = EmployeeField.reduce((a, el) => el.fieldDescription === 'Employee Id' && el.fieldValue ? el.fieldValue: a, '');
                                        //const usedhour = this.fusedhour(emp);
                                        return <AccordionTab key={empIndex} header={`${selEmployeeDet.label}`}>
                                            <div className="p-grid">
                                                {EmployeeField.map((field, fieldIndex) => {
                                                    return <div key={fieldIndex} className={"p-col-12 p-md-4 p-lg-2"}>
                                                        <Inputs
                                                            field={field}
                                                            value={field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',') || field.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, field)}
                                                            {...this.props}
                                                            {...this.state} />
                                                    </div>
                                                })}
                                            </div>
                                        </AccordionTab>
                                    })}
                                </Accordion>}

                                {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'DeMoblization'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null}
                                
                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence&& pendingWith !== null) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Link to={'/DeMoblization'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>  :
                                    
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <div className="p-col-12 p-md-6 p-lg-6">
                                        <label className="label">
                                            Employees <span className="requiredColor">*</span>
                                        </label>
                                        <div className="mt1"></div>
                                        <MultiSelect
                                            className="p-col-12"
                                            placeholder="Select Employees"
                                            options={employeeoptions} // Pass the list of options
                                            value={this.state.employees}    // Bind to the selected values in state
                                            onChange={(e) => this.Change(e)} // Update state on selection
                                            name="employees"                 // Name of the field
                                            {...DROPDOWN_CONFIG}            // Spread additional configuration
                                            display="chip" 
                                            style={{ height: "60px" }}   
                                            panelStyle={{ maxHeight: '200px', overflowY: 'auto' }}              // Optional: Display selected values as chips
                                        />
                                        </div>
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0&& pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0&& pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={(status && pendingWith !== null ? false : true)}onClick={() => this.downloadPDF('download')} className="p-button-success ml1" label="DownloadPDF" icon="pi pi-download" />
                                        <Button disabled={status && status === 'Closed' && pendingWith !== null ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />
                                        <Link to={'/DeMoblization'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}

                            </div>
                        </div>
                    </div>
                })}


                <Dialog header="Select Supervisor" visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">Select Supervisor<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder="Select Supervisor" name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }
}

const mapStateToProps = (state, props) => {

    const pageType = props.match.params.type;
    const emplist = state?.master?.keywordValuesList?.map(e => ({...e, value:e.uniqueId})) || []
    const subordinatesList = pageType === 'edit' && state.master.requestAttributeData  ? ([Object.assign({}, { label: `${state.master.requestAttributeData.employeename} (Self)`, value: state.master.requestAttributeData.employeeID })]).concat(state.master.subordinatesListData) : ([Object.assign({}, { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, userId: state.auth.userObject.userID })]).concat(state.master.subordinatesListData);
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

   

    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData: subordinatesList,
        keywordValuesList,
        metaData: Object.assign({}, {
            Shift: state.keyword.Shift,
            'Employees': subordinatesList,
            'Requested For': subordinatesList,
            'Employee Id': emplist,
            'OT Type': state.keyword.OTType,
            // 'Status': state.keyword.DemoblizeStatus, // ADD THIS LINE - maps DemoblizeStatus to Status dropdown
            'Status': state.keyword.DemoblizeStatus!==undefined ? state.keyword.DemoblizeStatus.filter(item => item.id !== 0) : [], // ADD THIS LINE - maps DemoblizeStatus to Status dropdown

        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(DeMoblization);